<template>
  <div class="container">
    <!-- Header Image -->
    <div class="header-image">
      <img src="@/assets/cg-workshop-image.png" alt="Succour Care Giver Workshop" />
    </div>

    <!-- Titles -->
    <div class="header-text">
      <h1>Succour Care Giver Workshop</h1>
      <h2>Terms & Conditions</h2>
      <p>Please read this carefully before registering. By registering for the workshop, you agree to the terms below.</p>
    </div>

    <!-- Terms Content -->
    <div class="terms-content">
      <section>
        <h3>1. ABOUT THE WORKSHOP</h3>
        <p>This workshop is organised by Succour Support Systems Limited to:</p>
        <ul>
          <li>Train Care Givers</li>
          <li>Collect required information</li>
          <li>Assess suitability for onboarding onto the Succour platform</li>
        </ul>
        <p>Registering does not mean automatic selection or employment.</p>
      </section>

      <section>
        <h3>2. INFORMATION & DATA COLLECTION</h3>
        <p>During the workshop, Succour may collect:</p>
        <ul>
          <li>Personal details (biodata)</li>
          <li>Samples for testing (medical-related)</li>
          <li>Biometric information</li>
          <li>Background check information</li>
          <li>Photographs and videos</li>
        </ul>
        <p>By registering, you consent to the use of this information for:</p>
        <ul>
          <li>Assessment and screening</li>
          <li>Training and onboarding</li>
          <li>Internal records</li>
          <li>Promotional and educational materials</li>
        </ul>
      </section>

      <section>
        <h3>3. USE OF PHOTOS & MEDIA</h3>
        <p>Succour may take photos or videos during the workshop, which may be used for marketing, promotions, reports, social media, and training materials. You agree that Succour can use these without payment or special permission.</p>
      </section>

      <section>
        <h3>4. SELECTION PROCESS</h3>
        <ul>
          <li>Not everyone who registers will be selected.</li>
          <li>Selection is based on Succour’s internal assessment and criteria.</li>
          <li>Succour’s decision on selection is final.</li>
        </ul>
      </section>

      <section>
        <h3>5. ONBOARDING TO SUCCOUR</h3>
        <ul>
          <li>Only selected participants will be onboarded.</li>
          <li>Onboarded Care Givers must follow Succour platform rules and guidelines.</li>
          <li>Rules may change. Continued use of the platform means you accept updates.</li>
        </ul>
      </section>

      <section>
        <h3>6. ENGAGEMENT & OPPORTUNITIES</h3>
        <ul>
          <li>Succour may engage successful trainees from time to time.</li>
          <li>Engagement depends on availability, performance, and Care Seeker needs.</li>
          <li>Regular work or income is not guaranteed.</li>
        </ul>
      </section>

      <section>
        <h3>7. BEHAVIOUR & CONDUCT</h3>
        <ul>
          <li>Provide truthful information</li>
          <li>Behave respectfully</li>
          <li>Follow facilitator instructions</li>
        </ul>
        <p>False information or bad behaviour may lead to disqualification.</p>
      </section>

      <section>
        <h3>8. WITHDRAWAL</h3>
        <p>You may withdraw at any time. Succour may disqualify participants who violate these terms.</p>
      </section>

      <section>
        <h3>9. AGREEMENT</h3>
        <ul>
          <li>You understand these terms</li>
          <li>You agree to them</li>
          <li>Your information is true and correct</li>
        </ul>
      </section>
    </div>

    <!-- Checkbox & Register -->

  </div>
</template>

<script>
export default {
  name: "CGWorkshopTerms",
  data() {
    return {
      agreed: false
    };
  },
  methods: {
    register() {
      alert("Thank you for registering!");
      // Add registration logic here
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 30px 20px;
  font-family: "Helvetica Neue", Arial, sans-serif;
  color: #1f2937;
  line-height: 1.6;
}

.header-image img {
  width: 200px;       /* smaller width */
  max-height: 120px;  /* limit height */
  object-fit: contain; /* keep aspect ratio */
  border-radius: 8px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;  /* center the image */
}

.header-text h1 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 5px;
  color: #111827;
}

.header-text h2 {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 10px;
  color: #f59cab;
}

.header-text p {
  font-size: 1rem;
  margin-bottom: 20px;
  color: #374151;
}

.terms-content section {
  margin-bottom: 20px;
}

.terms-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 10px;
}

.terms-content ul {
  list-style-type: disc;
  padding-left: 20px;
  margin-bottom: 10px;
}

.terms-content p {
  margin-bottom: 10px;
}

.checkbox-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 20px 0;
}

.checkbox-container input[type="checkbox"] {
  margin-top: 3px;
}

.checkbox-container label {
  font-size: 1rem;
  line-height: 1.5;
}

.link {
  color: #3b82f6;
  text-decoration: underline;
}

button {
  padding: 12px 20px;
  width: 100%;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
}
</style>
